/* eslint-disable no-unused-vars */
import apiClient from '@u/apiClient'
import GetDocumentVariableByModelController from '@/wayfinder/actions/App/Http/Controllers/Document/GetDocumentVariableByModelController'
import VariableExportController from '@/wayfinder/actions/App/Http/Controllers/Document/VariableExportController'

function processSuccessCallback(payload) {
  if (payload.successCallback) {
    payload.successCallback()
  }
}

const base_errors = {}

export default {
  // region fetch
  async fetchVariablesByModel({ commit }, payload) {
    await apiClient
      .route(GetDocumentVariableByModelController.post(), payload)
      .then(async (response) => {
        await commit('setVariables', response.data.variables)
      })
      .catch(async (reason) => {
        console.error('fetchVariablesByModel', reason)
      })
  },
  // endregion
  //region export items
  async fetchVariablesDataExport({ commit }, payload) {
    await apiClient
      .route(VariableExportController.post())
      .then(async (response) => {
        window.open(response.data.url)
        processSuccessCallback(payload)
      })
      .catch((reason) => {
        console.error('fetchVariablesDataExport', reason)
        commit('auth/setErrors', reason.response, { root: true })
      })
  }
  //endregion
}
